// Utility functions for withdrawal check components

// Format currency
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(amount);
};

// Format card number
export const formatCardNumber = (cardNumber?: string): string => {
  if (!cardNumber || cardNumber.length < 4) return 'N/A';
  return `***${cardNumber.slice(-4)}`;
};

// Format customer fee based on type
export const formatCustomerFee = (
  fee?: number,
  customerType?: '%' | 'vn'
): string => {
  if (!fee || fee === 0) return 'N/A';

  if (customerType === 'vn') {
    return formatCurrency(fee);
  } else {
    return `${fee}%`;
  }
};

// Transaction data type
export type TransactionData = any;
